// File generated from our OpenAPI spec
export const ApiVersion = '2024-12-18.acacia';
